// extracted by mini-css-extract-plugin
module.exports = {"centerIfAlone":"src-components-planSelection-priceSummary-summary-module__centerIfAlone--2dvGV"};